import { render, staticRenderFns } from "./option-items-setting.vue?vue&type=template&id=57416d0a&scoped=true&"
import script from "./option-items-setting.vue?vue&type=script&lang=js&"
export * from "./option-items-setting.vue?vue&type=script&lang=js&"
import style0 from "./option-items-setting.vue?vue&type=style&index=0&id=57416d0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57416d0a",
  null
  
)

export default component.exports